module.exports = __webpack_public_path__ + "static/media/footerTheme4.8a6ec4b8.svg";